// Swiper banner "Hoạt động" — Swiper v8 (global từ libraryMainsite, bundle swiper: true)
$(window).on("load", function () {
	// Swiper banner init LAZY (nav gọi khi mở view offline) — tránh init lúc view ẩn (width=0)
	window.f4Swiper = null;
	window.initF4Swiper = function () {
		if (window.f4Swiper) { window.f4Swiper.update(); return; }
		window.f4Swiper = new Swiper("#Frame4 .f4-swiper", {
			loop: true,
			slidesPerView: 1,
			speed: 500,
			navigation: { nextEl: "#Frame4 .f4-swiper-next", prevEl: "#Frame4 .f4-swiper-prev" },
			pagination: { el: "#Frame4 .f4-swiper-pagination", clickable: true },
		});
	};

	// === Nhân vật chạy dọc đường line theo mốc ngày của chuỗi Hội Hè Play ===
	// Nhân vật ĐỨNG GIỮA card (cPc/cMb), khi đổi mốc thì rời card -> bám đường cong (POLY_PC) -> lên giữa card kế.
	// idxPc = điểm vào/ra đường gần card (đáy card) trên POLY_PC. cPc/cMb = tâm card để nhân vật đứng giữa.
	var POLY_PC = [
		[688,1667],[690,1703],[692,1739],[710,1763],[744,1775],[778,1787],[812,1799],[846,1811],
		[880,1823],[912,1839],[942,1859],[972,1880],[1002,1902],[1032,1924],[1062,1946],[1092,1968],
		[1122,1990],[1152,2012],[1188,2019],[1224,2021],[1260,2023],[1296,2019],[1332,2013],[1368,2006],
		[1402,1996],[1434,1982],[1464,1962],[1494,1942],[1521,1917],[1542,1888],[1559,1856],[1570,1822],
		[1576,1786],[1557,1767],[1521,1771],[1485,1777],[1470,1810],[1458,1844],[1446,1878],[1434,1912],
		[1432,1948],[1427,1983],[1395,1998],[1361,2008],[1325,2016],[1289,2020],[1253,2022],[1217,2022],
		[1181,2016],[1145,2010],[1111,2000],[1077,1989],[1045,1974],[1014,1956],[984,1936],[954,1916],
		[924,1896],[894,1876],[864,1856],[836,1832],[810,1806],[784,1780],[758,1754],[732,1728],
		[700,1712],[668,1696],[636,1680],[602,1684],[572,1704],[544,1728],[520,1754],[500,1784],
		[480,1814],[463,1846],[458,1882],[460,1918],[465,1953],[475,1987],[491,2019],[509,2050],
		[532,2077],[557,2103],[585,2127],[615,2147],[646,2165],[678,2181],[710,2197],[743,2210],
		[777,2222],[811,2233],[845,2243],[881,2251],[917,2259],[953,2267],[989,2274],[1025,2276],
		[1061,2278],[1097,2280],[1133,2282],[1169,2284],[1205,2286],[1241,2288],[1277,2290],[1313,2292],
		[1349,2294],[1385,2296],[1421,2298],[1457,2300],[1493,2302],[1529,2302],[1565,2300],[1585,2329],
		[1591,2365],[1597,2401],[1603,2437],[1609,2473],[1615,2509],[1621,2545],[1619,2581],[1617,2617],
		[1609,2651],[1596,2685],[1578,2716],[1554,2742],[1525,2764],[1492,2778],[1457,2787],[1421,2789],
		[1385,2788],[1349,2782],[1313,2776],[1279,2766],[1245,2756],[1226,2725],[1208,2693],[1190,2661],
		[1172,2629],[1145,2607],[1113,2591],[1081,2575],[1049,2559],[1017,2543],[985,2527],[953,2511],
		[921,2495],[889,2479],[857,2463],[823,2451],[789,2439],[755,2429],[721,2419],[685,2411],
		[649,2403],[613,2401],[577,2399],[541,2398],[506,2406],[474,2421],[449,2447],[439,2482],
		[441,2518],[443,2554],[445,2590],[447,2626],[449,2662],[453,2698],[464,2732],[479,2765],
		[495,2797],[517,2825],[540,2852],[566,2878],[596,2900],[626,2922],[658,2938],[690,2954],
		[722,2970],[754,2985],[788,2997],[822,3009],[856,3020],[890,3030],[926,3038],[962,3046],
		[998,3054],[1034,3062],[1070,3070],[1106,3078],[1142,3082],[1178,3084],[1214,3086],[1250,3088],
		[1286,3090],[1322,3092],[1358,3094],[1394,3096],[1430,3098],[1466,3100],[1502,3102],[1536,3111],
		[1552,3144],[1566,3178],[1580,3212],[1588,3246],[1596,3280],[1604,3314],[1610,3350],[1612,3386],
		[1610,3422],[1604,3457],[1593,3491],[1576,3523],[1552,3550],[1522,3570],[1489,3584],[1453,3592],
		[1417,3593],[1381,3592],[1345,3590],[1309,3588],[1273,3586],[1237,3584],[1201,3582],[1165,3580],
		[1129,3578],[1093,3576],[1057,3574],[1021,3572],[985,3570],[949,3568],[913,3566],[877,3564],
		[841,3562],[805,3560],[769,3558],[733,3556],[697,3554],[661,3552],[625,3550],[608,3522],
	];
	var POLY_MB = [
		[512,1142],[514,1174],[516,1206],[518,1238],[527,1269],[539,1299],[551,1329],[563,1359],
		[575,1389],[587,1419],[599,1449],[600,1479],[584,1506],[562,1529],[534,1545],[503,1555],
		[471,1561],[439,1564],[407,1564],[375,1562],[343,1558],[311,1554],[280,1545],[252,1529],
		[224,1513],[201,1518],[193,1550],[189,1582],[189,1614],[191,1646],[193,1678],[195,1710],
		[197,1742],[199,1774],[201,1806],[203,1838],[205,1870],[207,1902],[218,1931],[247,1944],
		[279,1950],[311,1952],[343,1949],[375,1945],[405,1937],[435,1929],[465,1921],[495,1913],
		[521,1932],[541,1958],[557,1985],[569,2015],[578,2046],[585,2078],[590,2110],[592,2142],
		[594,2174],[592,2206],[590,2238],[588,2270],[584,2302],[574,2332],[558,2359],[535,2381],
		[508,2398],[476,2404],[444,2404],[412,2400],[382,2391],[352,2377],[322,2363],[293,2348],
		[265,2332],[240,2336],[225,2364],[213,2394],[201,2424],[192,2455],[184,2487],[176,2519],
		[169,2551],[166,2583],[168,2615],[170,2647],[176,2679],[188,2708],[207,2734],[231,2755],
		[259,2771],[290,2778],[322,2781],[354,2780],[386,2778],[418,2776],[450,2774],[482,2772],
		[513,2778],[536,2800],[555,2826],[571,2854],[583,2884],[592,2915],[600,2947],[605,2979],
		[608,3011],[610,3043],[608,3075],[606,3107],[604,3139],[602,3171],[597,3203],[588,3234],
		[576,3263],[562,3291],[543,3317],[521,3341],[495,3359],[467,3375],[437,3387],[406,3394],
		[374,3398],[342,3400],[310,3399],[278,3396],[246,3392],[214,3387],[209,3357],[228,3340],
		[260,3344],[292,3348],[324,3352],[356,3356],[388,3360],[420,3363],[452,3365],
	];
	var MILESTONES = [
		{ key: "cantho",    date: "2026-06-20", idxPc: 36,  idxMb: 6,   cPc: { left: 1507, top: 1560 }, cMb: { left: 533, top: 1130 } }, // Cần Thơ
		{ key: "nhatrang",  date: "2026-06-27", idxPc: 76,  idxMb: 32,  cPc: { left: 521,  top: 1660 }, cMb: { left: 226, top: 1545 } }, // Nha Trang
		{ key: "danang",    date: "2026-07-04", idxPc: 119, idxMb: 56,  cPc: { left: 1500, top: 2240 }, cMb: { left: 540, top: 1950 } }, // Đà Nẵng
		{ key: "quangninh", date: "2026-07-11", idxPc: 169, idxMb: 81,  cPc: { left: 521,  top: 2540 }, cMb: { left: 227, top: 2375 } }, // Quảng Ninh
		{ key: "hanoi",     date: "2026-07-18", idxPc: 208, idxMb: 103, cPc: { left: 1507, top: 3150 }, cMb: { left: 533, top: 2785 } }, // Hà Nội
		{ key: "hochiminh", date: "2026-07-25", idxPc: 238, idxMb: 125, cPc: { left: 518,  top: 3330 }, cMb: { left: 219, top: 3215 } }, // TP.HCM
	];

	// chạy hành trình: đặt nhân vật ở mốc hiện tại, glow card, animate dọc đường + cuộn tới card.
	// tách ra hàm để nav gọi lại MỖI LẦN mở view "SỰ KIỆN OFFLINE" (xem lại animation từ đầu).
	function runJourney() {
		var $char = $("#Frame4 .character");
		if (!$char.length) return;
		var el = $char[0];
		var isMobile = window.matchMedia("(max-width: 768px)").matches;

		// offset canh GIỮA nhân vật vào điểm (ảnh PC 351x260, mobile 252x187); OY nhích lên ~75px cho rõ chữ ngày
		var OX = isMobile ? -126 : -175;
		var OY = isMobile ? -123 : -205;
		function applyPos(pt) { el.style.left = (pt[0] + OX) + "px"; el.style.top = (pt[1] + OY) + "px"; }

		// === DEBUG: ép ngày test qua ?date=YYYY-MM-DD (hoặc gán DEBUG_DATE) ===
		var DEBUG_DATE = null;
		var qsDate = (location.search.match(/[?&]date=([0-9]{4}-[0-9]{2}-[0-9]{2})/) || [])[1];
		var forced = qsDate || DEBUG_DATE;
		var today = forced ? new Date(forced + "T00:00:00") : new Date();
		today.setHours(0, 0, 0, 0);
		if (forced) console.log("[Frame4] DEBUG ngày test:", forced);

		var reached = MILESTONES.filter(function (m) { return new Date(m.date + "T00:00:00") <= today; });
		// trước mốc đầu (chưa tới 20/6): nhân vật đứng + card Cần Thơ nhấp nháy ngay tại chỗ, không chạy đường
		if (!reached.length) {
			var first = MILESTONES[0];
			var c0 = isMobile ? first.cMb : first.cPc;
			$("#Frame4 .homes img").removeClass("is-active");
			$("#Frame4 .homes img." + first.key).addClass("is-active");
			el.style.transition = "none";
			applyPos([c0.left, c0.top]);
			$char.css("opacity", 1);
			setTimeout(function () {
				var t0 = document.querySelector("#Frame4 .homes img." + first.key);
				if (!t0) return;
				var r0 = t0.getBoundingClientRect();
				var y0 = r0.top + (window.pageYOffset || document.documentElement.scrollTop) - (window.innerHeight - r0.height) / 2;
				window.scrollTo({ top: y0, behavior: "smooth" });
			}, 300);
			return;
		}

		var lastIdx = MILESTONES.length - 1;
		var activeIndex = reached.length - 1;             // thành phố ĐANG tới kỳ sự kiện -> glow (điểm A)
		var charIndex = Math.min(activeIndex + 1, lastIdx); // nhân vật chạy tới thành phố kế (điểm B)
		var A = MILESTONES[charIndex - 1], B = MILESTONES[charIndex];
		console.log("[Frame4] nhân vật ở & card sáng:", B.key, "| chạy từ:", A.key);

		// glow card NƠI NHÂN VẬT ĐANG ĐỨNG (điểm B)
		$("#Frame4 .homes img").removeClass("is-active");
		$("#Frame4 .homes img." + B.key).addClass("is-active");

		// đường đi A -> B: bám hình dáng tim đường (PC: POLY_PC / mobile: POLY_MB),
		// "uốn" mượt dần 2 đầu về GIỮA card -> ôm sát đường, không vọt/giật ở đầu & cuối
		var poly = isMobile ? POLY_MB : POLY_PC;
		var iA = isMobile ? A.idxMb : A.idxPc;
		var iB = isMobile ? B.idxMb : B.idxPc;
		var cA = isMobile ? A.cMb : A.cPc;
		var cB = isMobile ? B.cMb : B.cPc;
		var road = poly.slice(iA, iB + 1);
		var rc = [0];
		for (var r = 1; r < road.length; r++) {
			var rx = road[r][0] - road[r - 1][0], ry = road[r][1] - road[r - 1][1];
			rc.push(rc[r - 1] + Math.sqrt(rx * rx + ry * ry));
		}
		var rtot = rc[rc.length - 1] || 1;
		var oA = [cA.left - road[0][0], cA.top - road[0][1]];
		var oB = [cB.left - road[road.length - 1][0], cB.top - road[road.length - 1][1]];
		var pathPts = road.map(function (p, i) {
			var s = rc[i] / rtot;
			// trọng số dồn về 2 đầu (mũ 5): GIỮA ~0 -> ôm sát tim đường; chỉ nhấc dần về tâm card ở 2 đầu
			var w0 = Math.pow(1 - s, 5), w1 = Math.pow(s, 5);
			return [p[0] + oA[0] * w0 + oB[0] * w1, p[1] + oA[1] * w0 + oB[1] * w1];
		});

		// độ dài tích luỹ để tween đều theo quãng đường
		var cum = [0];
		for (var k = 1; k < pathPts.length; k++) {
			var dx = pathPts[k][0] - pathPts[k - 1][0], dy = pathPts[k][1] - pathPts[k - 1][1];
			cum.push(cum[k - 1] + Math.sqrt(dx * dx + dy * dy));
		}
		var total = cum[cum.length - 1] || 1;

		function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
		function pointAt(dist) {
			if (dist <= 0) return pathPts[0];
			if (dist >= total) return pathPts[pathPts.length - 1];
			var i = 1; while (i < cum.length && cum[i] < dist) i++;
			var seg = cum[i] - cum[i - 1] || 1, f = (dist - cum[i - 1]) / seg;
			return [pathPts[i - 1][0] + (pathPts[i][0] - pathPts[i - 1][0]) * f,
			        pathPts[i - 1][1] + (pathPts[i][1] - pathPts[i - 1][1]) * f];
		}

		// đặt TỨC THÌ ở A (ẩn -> hiện) để tránh nhảy từ vị trí HTML ban đầu
		el.style.transition = "none";
		applyPos(pathPts[0]);
		void el.offsetWidth;
		$char.css("opacity", 1);

		var duration = Math.min(2800, Math.max(900, total * 1.1));
		function run() {
			var start = null;
			function frame(ts) {
				if (start === null) start = ts;
				var t = Math.min((ts - start) / duration, 1);
				applyPos(pointAt(easeInOut(t) * total));
				if (t < 1) requestAnimationFrame(frame);
			}
			requestAnimationFrame(frame);
		}

		// scroll tới card đang sáng (điểm B) — CHỈ cuộn DỌC, không đụng trục X (tránh trượt ngang lòi nền trắng)
		setTimeout(function () {
			var target = document.querySelector("#Frame4 .homes img." + B.key);
			if (!target) return;
			var rect = target.getBoundingClientRect();
			var y = rect.top + (window.pageYOffset || document.documentElement.scrollTop) - (window.innerHeight - rect.height) / 2;
			window.scrollTo({ top: y, behavior: "smooth" });
		}, 300);
		setTimeout(run, 800);
	}

	// expose cho nav gọi khi mở view offline.
	// KHÔNG chạy lúc load: nếu chạy sẵn (view đang ẩn) nhân vật sẽ về tới B, mở offline thấy nó ở B
	// rồi mới snap về A -> giật. Để nav gọi đồng bộ lúc mở -> nhân vật đặt ở A trước khi paint.
	window.runFrame4Journey = runJourney;
});
